export const GUIDES_MONTH_2026 = [
    {
        title: "How to plan a stress-free vacation",
        slug: "how-to-plan-a-stress-free-vacation",
        image: "/assets/guides/guides12.jpg",
        link: "/guides/how-to-plan-a-stress-free-vacation",
    },
    {
        title: "How to choose the right travel insurance",
        slug: "how-to-choose-the-right-travel-insurance",
        image: "/assets/guides/guides10.jpg",
        link: "/guides/how-to-choose-the-right-travel-insurance",
    },
    {
        title: "Activities worth booking in advance",
        slug: "activities-worth-booking-in-advance",
        image: "/assets/guides/guides11.jpg",
        link: "/guides/activities-worth-booking-in-advance",
    },
    {
        title: "How to avoid hidden fees when booking",
        slug: "how-to-avoid-hidden-fees-when-booking",
        image: "/assets/guides/hidden-fees.jpg",
        link: "/guides/how-to-avoid-hidden-fees-when-booking",
    },
    {
        title: "Best times to travel in Europe",
        slug: "best-times-to-travel-in-europe",
        image: "/assets/guides/europe-seasons.jpg",
        link: "/guides/best-times-to-travel-in-europe",
    },
    {
        title: "City-break vs long vacation",
        slug: "city-break-vs-long-vacation",
        image: "/assets/guides/guides5.jpg",
        link: "/guides/city-break-vs-long-vacation",
    },
    {
        title: "Vacations suitable for remote work",
        slug: "vacations-suitable-for-remote-work",
        image: "/assets/guides/remote-work.jpg",
        link: "/guides/vacations-suitable-for-remote-work",
    },
    {
        title: "How to find flight tickets more efficiently",
        slug: "how-to-find-flight-tickets-more-efficiently",
        image: "/assets/guides/guides2.jpg",
        link: "/guides/how-to-find-flight-tickets-more-efficiently",
    },
    {
        title: "Common mistakes when booking a vacation",
        slug: "common-mistakes-when-booking-a-vacation",
        image: "/assets/guides/guides3.jpg",
        link: "/guides/common-mistakes-when-booking-a-vacation",
    },
    {
        title: "How to use local activities wisely",
        slug: "how-to-use-local-activities-wisely",
        image: "/assets/guides/guides6.jpg",
        link: "/guides/how-to-use-local-activities-wisely",
    },
    {
        title: "When to book accommodation",
        slug: "when-to-book-accommodation",
        image: "/assets/guides/guides4.jpg",
        link: "/guides/when-to-book-accommodation",
    },
    {
        title: "Travel planning checklist",
        slug: "travel-planning-checklist",
        image: "/assets/guides/guides1.jpg",
        link: "/guides/travel-planning-checklist",
    },
];
